import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'
import { exists } from '~/utils'

import { useStrategyMemoId } from './useStrategyMemoId'

const document = graphql(`
  mutation StrategyMemoEditPage_CloneStrategyMemo($strategyMemoId: ID!) {
    copyCustomerStrategyMemo(id: $strategyMemoId) {
      id
    }
  }
`)

export const useCloneStrategyMemoMutation = (
  options: MutationOptions<string, void> = {},
) => {
  const { t } = useTranslation()
  const graphQLRequest = useGraphQLRequest()
  const strategyMemoId = useStrategyMemoId()

  return useMutation({
    mutationFn: async () => {
      const result = await graphQLRequest({
        document,
        variables: { strategyMemoId },
      })
      const clonedStrategyMemoId = result.copyCustomerStrategyMemo?.id
      if (!exists(clonedStrategyMemoId)) {
        throw new Error(t('duplication_failed_2'))
      }

      return clonedStrategyMemoId
    },
    ...options,
  })
}
